import { render, staticRenderFns } from "./ChiselIntroduce.vue?vue&type=template&id=4fd0f4de&scoped=true&"
import script from "./ChiselIntroduce.vue?vue&type=script&lang=js&"
export * from "./ChiselIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./ChiselIntroduce.vue?vue&type=style&index=0&id=4fd0f4de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd0f4de",
  null
  
)

export default component.exports